import React, { useEffect, useState } from "react";
import CallToAction from "../partials/cta";
import CircularProgress from "@mui/material/CircularProgress";
import FieldLabel from "../../../components/label";
import HeightConversion from "./converter";
import SectionTitle from "../../../components/sectionTitle";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";
import { Box, Stack, TextField, Typography } from "@mui/material";
import { getRoute, getStorageItem } from "../../../helpers/utils";
import {
  calculateBMI,
  feetAndInchesToCm,
  setStorageItem,
  validateInputLength,
} from "../../../helpers/utils";
import { Utils } from "../../../constants/utils";
import { validations } from "../../../messages/validation";
import { useHistory } from "react-router";
import {
  MESSAGE_SAVINGS_HEALTH_DECLARATION,
  MESSAGE_BMI_OUT_OF_RANGE,
} from "../../../constants";
import { postWebService } from "../../../helpers/server";

function BuyflowHealthDeclaration({
  classes: {
    borderContainter,
    containerButton,
    contentScroller,
    formGroup,
    loaderBox,
    main,
  },
}) {
  const history = useHistory();
  const [isLoaded, setIsLoaded] = useState(true);
  const [errorMessage, setErrorMessage] = useState({
    height: "",
    heightFeet: "",
    heightInch: "",
    heightCm: "",
    weight: "",
    bmi: "",
  });
  const [errors, setErrors] = useState([]);
  const [form, setForm] = useState({
    height: "",
    heightFeet: 5,
    heightInch: 5,
    heightCm: 165,
    weight: "",
    bmi: "",
  });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [modal, setModal] = useState({
    details: false,
    open: false,
    review: false,
    snackbar: false,
  });
  const [onfocusMobile, setOnfocusMobile] = useState(false);
  const [touchFields, setTouchFields] = useState({
    height: false,
    weight: false,
    bmi: false,
  });

  useEffect(() => {
    validateHeightWeightInput("weight");
    form.weight &&
      setForm({
        ...form,
        bmi: calculateBMI(form),
      });
  }, [form.weight]);

  useEffect(() => {
    validateHeightWeightInput("height");
    form.height &&
      setForm({
        ...form,
        bmi: calculateBMI(form),
      });
  }, [form.height]);

  useEffect(() => convertToCm(), [form.heightFeet]);

  useEffect(() => convertToCm(), [form.heightInch]);

  const convertToCm = () => {
    setForm({
      ...form,
      heightInch: form.heightInch === "" ? 0 : form.heightInch,
      heightCm: feetAndInchesToCm(form.heightFeet, form.heightInch),
    });
  };

  const handleChange = (event) => {
    setErrors([]);
    setFormState(event.target.name, event.target.value);
  };

  const handleCheckHeightClick = (event) => toggleModal("open", true);

  const handleModalClose = (keyname = "open", flag = false) =>
    toggleModal(keyname, false);

  const setErrorMessageState = (name, value) =>
    setErrorMessage({ ...errorMessage, [name]: value });

  const setFormState = (name, value) => setForm({ ...form, [name]: value });

  const setStateVariables = (key, isValid, message) => {
    setFormState("hasError", !isValid);
    setErrorMessageState(key, message);
    setTouchFieldsState(key, true);
  };

  const toggleModal = (keyname = "open", flag = true) =>
    setModal({ ...modal, [keyname]: flag });

  const setTouchFieldsState = (name, value) =>
    setTouchFields({ ...touchFields, [name]: value });

  const validateRequiredInput = (fieldName) => {
    if (form[fieldName]) {
      setTouchFieldsState(fieldName, true);
      setErrorMessageState(fieldName, "");
    } else if (touchFields[fieldName] && !form[fieldName]) {
      setErrorMessageState(fieldName, validations[fieldName].required);
    }
  };

  const validateHeightWeightInput = (fieldName) => {
    if (form[fieldName]) {
      if (fieldName === "height") {
        if (
          form[fieldName] < Utils.limit.height.min ||
          form[fieldName] > Utils.limit.height.max
        ) {
          setTouchFieldsState(fieldName, true);
          setErrorMessageState(fieldName, validations[fieldName].valid);
        } else {
          setTouchFieldsState(fieldName, true);
          setErrorMessageState(fieldName, "");
        }
      } else if (fieldName === "weight") {
        if (
          form[fieldName] < Utils.limit.weight.min ||
          form[fieldName] > Utils.limit.weight.max
        ) {
          setTouchFieldsState(fieldName, true);
          setErrorMessageState(fieldName, validations[fieldName].valid);
        } else {
          setTouchFieldsState(fieldName, true);
          setErrorMessageState(fieldName, "");
        }
      }
    } else if (touchFields[fieldName] && !form[fieldName]) {
      setErrorMessageState(fieldName, validations[fieldName].required);
    }
  };

  const navigateTo = (pathname) => history.push({ pathname });

  const handleAcceptClick = () => navigateTo(getRoute("healthAssessment"));

  const handleBack = () => navigateTo(`${getRoute("overview")}/1`);

  const handleProceed = () => {
    setFormState("height", Math.round(form.heightCm));
    toggleModal("open", false);
  };

  const handleClose = (keyname = "open", flag = false) =>
    toggleModal(keyname, flag);

  const handleOnClose = (event, reason, modalKey) => {
    if (Utils.dialogOnCloseReasons.indexOf(reason) === -1) {
      handleClose(modalKey, false);
    }
  };

  const isBMIAppropriate = () =>
    form.bmi >= Utils.limit.bmi.min && form.bmi <= Utils.limit.bmi.max;

  const isContactAvivaButtonVisible = () => {
    return (
      !isBMIAppropriate() &&
      form.weight >= Utils.limit.weight.min &&
      form.weight <= Utils.limit.weight.max &&
      form.height >= Utils.limit.height.min &&
      form.height <= Utils.limit.height.max
    );
  };

  const cbError = (error = "An error occured, please try again.") => {
    setIsFormSubmitted(false);
    setErrors(new Array(error));
  };

  const updateOrderDetails = async () => {
    try {
      const response = await postWebService("update-order.php", {
        oid: Number(getStorageItem("oid")),
        status: "HEALTHDECLARATION",
      });

      if (response.data.code === 201) {
        setIsFormSubmitted(false);
        navigateTo(getRoute("healthAssessment"));
      }
    } catch (error) {
      cbError(error);
    }
  };

  const cbTermimateJourney = () => {
    setStorageItem("journeyCloseReason", MESSAGE_BMI_OUT_OF_RANGE);
    navigateTo(getRoute("terminated"));
  };

  const cbSuccessUpdateCustomer = (terminated) => {
    if (terminated) {
      setIsFormSubmitted(false);
      cbTermimateJourney();
    } else {
      updateOrderDetails();
    }
  };

  const updateCustomerDetails = async (terminated = false) => {
    try {
      setIsFormSubmitted(true);
      const response = await postWebService("update-customer.php", {
        cid: Number(getStorageItem("cid")),
        bmi: form.bmi,
        height: parseInt(form.height, 10),
        weight: parseInt(form.weight, 10),
      });

      if (response.data.code === 200) {
        cbSuccessUpdateCustomer(terminated);
      }
    } catch (error) {
      cbError(error);
    }
  };

  const handleDeclineClick = async () => updateCustomerDetails(true);

  const onSubmit = (event) => {
    event.preventDefault();

    updateCustomerDetails(false);
  };

  const onSubmitConversion = (event) => {
    event.preventDefault();

    handleProceed();
  };

  return isLoaded ? (
    <Box className={main}>
      <form noValidate autoComplete="off" onSubmit={onSubmit}>
        <Box container={"true"} justifyContent="center">
          <Box display="flex" justifyContent="center" m={2} mb={0}>
            <SectionTitle
              title={"Your Health Assessment"}
              onClickHandler={handleBack}
            />
          </Box>

          <Box textAlign={"left"} className={contentScroller}>
            <Box className={formGroup}>
              <Stack
                direction="row"
                gap={6}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <FieldLabel
                  label={`Height in cm* (${Utils.limit.height.min}-${Utils.limit.height.max} cm)`}
                />
              </Stack>

              <TextField
                type="text"
                id="standard-basic"
                variant="outlined"
                value={form.height}
                name="height"
                onInput={validateInputLength}
                onChange={handleChange}
                autoComplete="off"
                helperText={errorMessage.height}
                fullWidth
              />
            </Box>

            <Box
              display="flex"
              justifyContent="flex-end"
              alignContent="flex-end"
              textAlign="right"
              fullWidth
              sx={{ width: "98%" }}
            >
              <Typography
                variant="caption"
                color="secondary"
                onClick={handleCheckHeightClick}
              >
                <small>
                  <b>Height Converter</b>
                </small>
              </Typography>
            </Box>

            <Box className={formGroup} mb={2}>
              <FieldLabel
                label={`Weight in kg* (${Utils.limit.weight.min}-${Utils.limit.weight.max} kg)`}
              />
              <TextField
                type="text"
                id="standard-basic"
                variant="outlined"
                value={form.weight}
                name="weight"
                onInput={validateInputLength}
                onChange={handleChange}
                autoComplete="off"
                helperText={errorMessage.weight}
                fullWidth
              />
            </Box>

            <Typography variant="caption">
              I hereby declare that:
              <br />I have never suffered from or undergoing any treatment for
              any cardiovascular, renal, musculoskeletal, neurological, nervous,
              nephrological, skeletal, respiratory, digestive, uninary,
              endocrine, lymphatic disorder or cancer and my family, including
              me, do not have any advers medical history. None of my parent/s or
              my sibling/s having died before the age 50 due to any adverse
              chronic ailment. I do not have any habit of smoking or
              conssumption of alcohol and been advised to quit or under
              treatment for related diagnois, nor overweight or underweight as
              per WHO standards. I also declare that I do not have any physical,
              mental, or sensory disability, nor have ever been treated for the
              same.
            </Typography>
          </Box>

          <Box className={containerButton} sx={{ backgroundColor: "#ffffff" }}>
            {form.weight &&
              form.height &&
              !(errorMessage.weight || errorMessage.height) && (
                <Box
                  className={borderContainter}
                  pl={1}
                  pr={1}
                  pt={0.5}
                  ml={0.5}
                  mr={0.5}
                  mt={1}
                  mb={1}
                >
                  <Box className={formGroup} pt={0}>
                    <Box
                      display="flex"
                      justifyContent="flex-start"
                      alignItems="left"
                      color="white"
                    >
                      {isBMIAppropriate() ? (
                        <Typography
                          variant="caption"
                          color="green"
                          fontWeight={450}
                        >
                          {`You are good to move ahead as your BMI of ${form.bmi} is
                            within the acceptable range.`}
                        </Typography>
                      ) : (
                        <Typography
                          variant="caption"
                          color="red"
                          fontWeight={450}
                        >
                          {`Sorry, you cannot proceed as your BMI of ${form.bmi} is outside the acceptable range.`}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Box>
              )}

            {!isContactAvivaButtonVisible() && (
              <Box>
                <CallToAction
                  errorMessage={errorMessage}
                  form={form}
                  isFormSubmitted={false}
                  isDisabled={
                    !form.weight ||
                    !form.height ||
                    errorMessage.weight ||
                    errorMessage.height ||
                    isFormSubmitted
                  }
                  text={"Proceed to Health Check"}
                />
              </Box>
            )}

            {isContactAvivaButtonVisible() && (
              <Box>
                <CallToAction
                  buttonType="click"
                  color="decline"
                  errorMessage={errorMessage}
                  form={form}
                  handleClick={handleDeclineClick}
                  isDisabled={
                    !form.weight ||
                    !form.height ||
                    errorMessage.weight ||
                    errorMessage.height ||
                    isFormSubmitted
                  }
                  isFormSubmitted={false}
                  text={"Decline Journey"}
                />
              </Box>
            )}
          </Box>
        </Box>
      </form>
      <HeightConversion
        errorMessage={errorMessage}
        form={form}
        handleChange={handleChange}
        onClose={handleOnClose}
        handleProceed={handleProceed}
        modal={modal}
        onSubmit={onSubmitConversion}
      />
    </Box>
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(
  BuyflowHealthDeclaration
);
